<template>
  <div>
    <slot 
      v-if="teleportTargetExists"
      v-bind="{ getItem, disableTeleportList, closeDropdown }"
    />
    <aw-dropdown 
      :class="dropdownClass" 
      :hover="true"
      placement="bottom"
      v-model="dropdownOpened"
    >
      <template v-slot:btn="{ open }">
        <slot 
          v-if="dropdownHasItems"
          name="btn"
          v-bind="{ open, getMenuBtn }"
        />
      </template>
      <template v-slot:dropdown="{ opened, dropdown }">
        <component 
          v-show="opened" 
          :class="dropdownMenuClass" 
          :id="teleportId"
          :is="dropdownTag"
          :ref="(el) => { dropdownMounted(el, dropdown); }"
        />
      </template>
    </aw-dropdown>
  </div>
</template>

<script>
import throttle from 'lodash/throttle'

export default {
  props: {
    dropdownClass: {
      type: String,
      default: 'dropdown'
    },
    dropdownMenuClass: {
      type: String,
      default: 'dropdown-menu AwPriorityNav__DropdownMenu'
    },
    dropdownTag: {
      type: String,
      default: 'div'
    },
    teleportId: {
      type: String,
      default: 'awMenuDropdown'
    },
    itemsCount: Number
  },
  data() {
    return {
      disableTeleportList: {},
      dropdownHasItems: false,
      menuBtn: null,
      menuWrapperObserver: null,
      slotItems: {},
      widthsMeasured: false,
      dropdownOpened: false,
      leftOffset: 0,
      teleportTargetExists: false,
      dropdownIsMounted: false,
      working: false,
    }
  },
  methods: {
    getMenuBtn(el) {
      if (el instanceof HTMLElement) {
        this.menuBtn = el
      } else if (el) {
        this.menuBtn = el.$el
      }
    },
    getItem(el, index) {
      if (el && this.slotItems[index] && (this.slotItems[index].el === el || (el.$el && this.slotItems[index].el === el.$el))) {
        return
      }

      this.disableTeleportList[index] = true
      this.slotItems[index] = {}

      if (el instanceof HTMLElement) {
        this.slotItems[index].el = el
      } else if (el) {
        this.slotItems[index].el = el.$el
      }

      if (index + 1 === this.itemsCount) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.measureWidths()
          })
        })
      }
    },
    handleMenu() {
      if (this.working) {
        return
      }

      this.working = true
      const menuWrapperWidth = this.$el.offsetWidth
      const menuBtnWidth = this.dropdownHasItems && this.menuBtn ? this.menuBtn.offsetWidth : 0

      for (const key of Object.keys(this.slotItems)) {
        if (this.slotItems[key].leftAndWidth < menuWrapperWidth - menuBtnWidth ) {
          this.disableTeleportList[key] = true
          this.dropdownHasItems = false
        } else {
          this.disableTeleportList[key] = false
          this.dropdownHasItems = true
        }
      }

      this.working = false
    },
    measureWidths() {
      this.leftOffset = this.$el.getBoundingClientRect().left
      
      for (const key of Object.keys(this.slotItems)) {
        this.slotItems[key].leftAndWidth = this.slotItems[key].el.getBoundingClientRect().left + this.slotItems[key].el.getBoundingClientRect().width - this.leftOffset
      }
      this.widthsMeasured = true
      this.onResize()
    },
    onResize() {
      if (!this.widthsMeasured || !this.teleportTargetExists) {
        return
      }

      this.handleMenu()
    },
    closeDropdown(curentDropdownClose) {
      if (typeof curentDropdownClose === 'function') {
        curentDropdownClose()
      }

      this.dropdownOpened = false
    },
    dropdownMounted(el, dropdown) {
      if (this.dropdownIsMounted) {
        return
      }
      dropdown(el)
      this.teleportTargetExists = true
      this.onResize()
      this.dropdownIsMounted = true
    }
  },
  mounted() {
    this.menuWrapperObserver = new ResizeObserver(throttle(this.onResize))
    this.menuWrapperObserver.observe(this.$el)
  },
  beforeUnmount() {
    this.menuWrapperObserver.disconnect()
  },
}
</script>

<style lang="scss">
  .AwPriorityNav__DropdownMenu {
    overflow: visible !important;
  }
</style>
